import { Box, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react'
import { GET_DATA_PAYMENT_LINE } from 'shared/api';
import { apiInstance } from 'shared/api/config/apiInstance';
import { CustomFileUploader, Spinner} from 'shared/components';
import { Field, Form, Formik } from 'formik';
import { fieldsFormInfo, fieldsFormPayment, payLineInfo } from './helper/fieldsForm';
import { usePrepareInvoice } from './hooks/usePrepareInvoice';
import { useSelector } from 'react-redux';
import { RootState } from 'shared/store/store';
import Image from 'shared/assets/index';
import styles from './styles/prepareInvoice.module.scss';
import { NumericFormat } from 'react-number-format';

interface IPrepareInvoice {
  isHadleSubmit: boolean,
  setIsHadleSubmit: React.Dispatch<React.SetStateAction<boolean>>,
  setIsNextPage: React.Dispatch<React.SetStateAction<boolean>>
}

export const PrepareInvoice = ({ isHadleSubmit, setIsHadleSubmit, setIsNextPage }: IPrepareInvoice) => {

  const {
    payLine,
    isPaidValue,
    document,
    typeAccept,
    isUnderage,
    prepareInvoiceData,
    handleChangeRadioUnderage,
    handleChangeSelect,
    handleBlurSelectDepartment,
    handleSubmit,
    handleChangeRadioPaidValue,
    validationSchema,
    handleChangeFile,
    removeFile,
    onlyNumbers,
    formikRef,
    codesMinors,
    isLoading
  } = usePrepareInvoice(isHadleSubmit, setIsHadleSubmit, setIsNextPage);

  const { optionsDropdowns } = useSelector((state: RootState) => state);
  const [paymentList, setPaymentList] = useState<any[]>([]);
  const [dataFields, setDataFields] = useState<any[]>([]);
  const [dataPayLineInfo, setDataPayLineInfo] = useState<any[]>([]);

  useEffect(() => {
    async function fetchData() {
      const response = await apiInstance.get(GET_DATA_PAYMENT_LINE);
      setPaymentList(response.data);
    }
    fetchData();
  }, [])

  useEffect(() => {
    const fields = fieldsFormInfo(optionsDropdowns);
    const paylineFields = payLineInfo(optionsDropdowns);
    setDataFields(fields);
    setDataPayLineInfo(paylineFields);
  }, [optionsDropdowns])

  return (
    <Fragment>
      <div className={styles.container}>
        <Formik
            innerRef={formikRef}
            initialValues={{
              recoveryValue: '',
              paidValue: '',
              typeDocument: '',
              documentNumber: '',
              names: '',
              lastNames: '',
              tel1: '',
              tel2: '',
              email: '',
              address: '',
              department: '',
              city: '',
              typeDocumentPatientSeen: '',
              documentNumberPatientSeen: '',
              namePatientSeen: '',
              LastNamePatientAttended: '',
              payLine: '',
              isLoadFile: null
            }}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            enableReinitialize={true}
            validateOnBlur={true}
            validateOnChange={true}
          >
            {
              formik => (
                <Form className={styles.formPrepareInvoice} data-testid='form-invoice'
                  onChange={(value: any) => {
                    if (value.target.id === 'itemTypeDocumentPatientSeen') {
                      handleChangeRadioUnderage(value);
                    }
                    if (value.target.id === 'itemNamePatientSeen' && !isUnderage) {
                      formik.setFieldValue('names', value.target.value)
                    }
                    if (value.target.id === 'itemLastNamePatientAttended' && !isUnderage) {
                      formik.setFieldValue('lastNames', value.target.value)
                    }
                    if (value.target.id === 'itemDocumentPatientSeen' && !isUnderage) {
                      formik.setFieldValue('documentNumber', value.target.value)
                    }
                  }}
                >
                  <Grid container>
                    <Grid container direction={"row"}>
                      <Grid item xs={12} className={styles.contentTitleMain}>
                        <img src={Image.iconoInfoContact} alt="" />
                        <Typography className={styles.subtitleMain}>Información de Clasificación de la Factura</Typography>
                      </Grid>
                      <Grid item xs={12} md={12} lg={6} className={styles.gridRadioButtons}>
                        <FormControl  className={` ${styles.itemForm} ${styles.noJustifyContentCenter}`}>
                          <label htmlFor="select-pay-line" className='text-required'>Línea de Pago:</label>
                          <select
                            id="select-payline"
                            value={payLine}
                            onChange={handleChangeSelect}
                            data-testid='select_pay_line'
                            className={formik.touched['payLine'] && Object.keys(formik.errors).includes('payLine') ? `${styles.itemForm} ${styles.errorCampoSelect}` : ""}
                            name='payLine'
                          >
                            <option value="">--</option>
                            {paymentList.map((line) => (
                              <option
                              key={line.id}
                              value={line.id}
                              data-testid={`menu_item_${line.id}`}
                              >
                                {line.name}
                              </option>
                            ))}
                          </select>
                            <Box display='flex' justifyContent='space-between'>
                              <span className={styles.spanError}>
                                {formik.touched['payLine'] &&  Object.keys(formik.errors).includes('payLine') && 'Campo obligatorio'}
                              </span>
                            </Box>
                        </FormControl>
                      </Grid>
                      {
                        dataPayLineInfo.map((field, i) => (
                        field.type === 'select' ?
                        <Grid item xs={12} md={6} lg={6} key={i}>
                          <FormControl fullWidth className={styles.itemForm}>
                            <label htmlFor={field.id} className={`${field.required && 'text-required'}`}>{field.label} </label>
                            <Field
                                id={field.id}
                                placeholder={field.placeholder}
                                variant="outlined"
                                name={field.name}
                                maxLength={field.maxLength}
                                className={formik.touched[field.name] && Object.keys(formik.errors).includes(field.name) ? styles.errorCampo : ""}
                                as={field.type}
                                onBlur={(e: any) => {
                                  formik.setFieldTouched(field.name);
                                }}
                                data-testid={`select_${field.name}`}
                            >
                              <option value=''>--</option>
                              {
                                  field.options?.map((option: any) => (
                                      <option key={option.id} value={option.id}>
                                          {option.name}
                                      </option>
                                  ))
                              }
                            </Field>
                            <Box display='flex' justifyContent='space-between'>
                              <span className={styles.spanError}>
                                { formik.touched[field.name] && Object.keys(formik.errors).includes(field.name) && 'Campo obligatorio'}
                              </span>
                            </Box>
                          </FormControl>
                        </Grid>
                        : field.type === 'textNumber' ?
                        <Grid item xs={12} md={6} lg={4} key={i}>
                          <FormControl fullWidth className={styles.itemForm}>
                            <label htmlFor={field.id} className={`${field.required && 'text-required'}`}>{field.label}</label>
                            <div
                              className={`${styles.containerItemTel} ${field.required && (Object.keys(formik.errors).includes(field.name) || formik.values[field.name] === '') && formik.touched[field.name] && styles.errorCampo}`}>
                              <Field
                                id={field.id}
                                placeholder={field.placeholder}
                                type={field.type}
                                variant="outlined"
                                name={field.name}
                                maxLength={field.maxLength}
                                className={""}
                                autoComplete='off'
                                onBlur={() => formik.setFieldTouched(field.name)}
                                onKeyPress={(event: any) => {
                                  isNaN(Number(event.key)) &&
                                      event.preventDefault();
                                  }}
                                onPaste={onlyNumbers}

                              />
                              <span className={styles.itemIndicator}>+57</span>
                            </div>
                            <Box display='flex' justifyContent='space-between'>
                              <span className={styles.spanError}>
                                {field.required && (Object.keys(formik.errors).includes(field.name) || formik.values[field.name] === '') && formik.touched[field.name] && 'Campo obligatorio'}
                              </span>
                              <span className={styles.spanCounter}>
                                { formik?.values?.[field.name]?.toString().length || 0}/{field.maxLength}
                              </span>
                            </Box>
                          </FormControl>
                        </Grid>
                        : (
                            <Grid item xs={12} md={6} lg={4} className={styles.gridRadioButtons} key={i}>
                              <FormControl fullWidth className={styles.itemForm}>
                                <label htmlFor={field.id} className={`${field.required && 'text-required'}`}> {field.label} </label>
                                <Field
                                  id={field.id}
                                  placeholder={field.placeholder}
                                  type={field.type}
                                  variant="outlined"
                                  name={field.name}
                                  maxLength={field.maxLength}
                                  className={field.required && Object.keys(formik.errors).includes(field.name) ? formik.touched[field.name] && styles.errorCampo : ""}
                                  data-testid={`input_${field.name}`}
                                />
                                <Box display='flex' justifyContent='space-between'>
                                  <span className={styles.spanError}>
                                    {Object.keys(formik.errors).includes(field.name) && formik.touched[field.name] && 'Campo obligatorio'}
                                  </span>
                                  <span className={styles.spanCounter}>
                                    { formik?.values?.[field.name]?.toString().length || 0}/{field.maxLength}
                                  </span>
                                </Box>
                              </FormControl>
                            </Grid>
                          )
                        ))
                      }
                      <Grid item xs={12} md={6} lg={4}  >
                        <FormControl fullWidth className={styles.itemForm}>
                          <FormLabel id="radio-buttons-values" className={`${styles.labelNumberAgreement} text-required`}>¿Se realizo gestión de cobro de cuota de recuperación?</FormLabel>
                          <RadioGroup
                            aria-labelledby="radio-buttons-values"
                            defaultValue="SI"
                            name="radio-buttons-values"
                            row
                            value={isPaidValue}
                            onChange={handleChangeRadioPaidValue}
                            data-testid='button_radio_group'
                            className={styles.radioGroup}
                          >
                            <FormControlLabel value={true} data-testid='is_paid_si' control={<Radio />} label="SI" />
                            <FormControlLabel value={false} data-testid='is_paid_no' control={<Radio />} label="NO" />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      {
                        fieldsFormPayment.map((fieldPayment,i)=> (
                          <Grid item xs={12} md={6} lg={4}  key={i}>
                            <FormControl fullWidth className={styles.itemForm}>
                              <label htmlFor={fieldPayment.id} className={`${fieldPayment.required && 'text-required'}`} >{fieldPayment.label} </label>
                              <NumericFormat
                                  thousandSeparator={'.'}
                                  decimalSeparator={','}
                                  className={ fieldPayment.name === 'paidValue' && !isPaidValue ? '' :
                                    (Object.keys(formik.errors).includes(fieldPayment.name) || formik.values[fieldPayment.name] === '') && formik.touched[fieldPayment.name] ? styles.errorCampo : ""
                                  }
                                  type={'text'}
                                  decimalScale={2}
                                  maxLength={13}
                                  value={formik.values[fieldPayment.name]}
                                  prefix="$"
                                  id={fieldPayment.id}
                                  placeholder={fieldPayment.placeholder}
                                  name={fieldPayment.name}
                                  onPaste={(e: any) => e.preventDefault()}
                                  onBlur={() => formik.values[fieldPayment.name].toString().trim() === '' ? formik.setFieldTouched(fieldPayment.name) : formik.setFieldTouched(fieldPayment.name, false)}
                                  onChange={(formattedValue: any) => {
                                    formik.setFieldValue(fieldPayment.name, formattedValue.target.value);
                                  }}
                                  disabled={(fieldPayment.name === 'paidValue' && !isPaidValue)  }
                              />
                              <Box display='flex' justifyContent='space-between'>
                                <span className={styles.spanError}>
                                {fieldPayment.name === 'paidValue' && !isPaidValue ? '' : (Object.keys(formik.errors).includes(fieldPayment.name) || formik.values[fieldPayment.name] === '') && formik.touched[fieldPayment.name] && 'Campo obligatorio'}
                                </span>
                                <span className={styles.spanCounter}>
                                  { formik?.values?.[fieldPayment.name]?.toString().replace(/\D/g, '').length || 0}/10
                                </span>
                              </Box>
                            </FormControl>
                          </Grid>
                        ))
                      }
                    </Grid>

                    <Grid item xs={12}  marginTop='1rem' className={styles.itemDocument}>
                      <label className='text-required'>Formato diligenciado de no capacidad de pago </label>
                      {
                        prepareInvoiceData?.file &&
                          <div className={styles.documentContainerText}>
                            <Typography>Actualmente tienes adjunto un formato en PDF.</Typography>
                          </div>
                      }
                      <CustomFileUploaderMemo
                        fileLength={10}
                        originalName={document?.name || ''}
                        typeAccept={typeAccept}
                        document={document}
                        handleChangeFile={handleChangeFile}
                        removeFile={removeFile}
                      />
                      <Box display='flex' justifyContent='space-between'>
                        <span className={styles.spanError}>
                          { formik.errors?.isLoadFile && 'Archivo obligatorio' }
                        </span>
                      </Box>

                    </Grid>
                  </Grid>

                  {
                    formikRef.current?.values.recoveryValue !== formikRef.current?.values.paidValue && 
                      <Grid container className={styles.contentInfo}>
                        <Grid item xs={12} className={styles.contentTitleMain}>
                          <img src={Image.iconoInfoContact} alt="" />
                          <Typography className={styles.subtitleMain}>Información de contacto para gestión de cobro de Cuota de recuperación</Typography>
                        </Grid>
                        {
                          codesMinors.includes(formikRef.current?.values.typeDocumentPatientSeen) &&(
                            <Grid item xs={12} className={styles.contentLabelMain}>
                              <span>Al tratarse de un menor de edad, deberá relacionar la información de un adulto responsable del pago. Por favor, complete los siguientes campos:</span>
                            </Grid>
                          )
                        }
                        {/* ***agregar en el formilk****** */}
                        
                        {
                          dataFields.map((fieldData,i)=> (
                            fieldData.type === 'select' ?
                            <Grid item xs={12} md={6} lg={4} key={i}>
                              <FormControl fullWidth className={styles.itemForm}>
                                <label htmlFor={fieldData.id} className={`${fieldData.required && 'text-required'}`}>{fieldData.label} </label>
                                <Field
                                    id={fieldData.id}
                                    placeholder={fieldData.placeholder}
                                    variant="outlined"
                                    name={fieldData.name}
                                    maxLength={fieldData.maxLength}
                                    className={formik.touched[fieldData.name] && Object.keys(formik.errors).includes(fieldData.name) ? styles.errorCampo : ""}
                                    as={fieldData.type}
                                    onBlur={(e: any) => {
                                      formik.setFieldTouched(fieldData.name);
                                      fieldData.id === "itemformDeparment" ? handleBlurSelectDepartment(e): formik.validateForm()
                                    }}
                                    data-testid={`select_${fieldData.name}`}
                                >
                                  <option value=''>--</option>
                                  {
                                      fieldData.options?.map((option: any) => (
                                          <option key={option.id} value={option.id}>
                                              {option.name}
                                          </option>
                                      ))
                                  }
                                </Field>
                                <Box display='flex' justifyContent='space-between'>
                                  <span className={styles.spanError}>
                                    { formik.touched[fieldData.name] && Object.keys(formik.errors).includes(fieldData.name) && 'Campo obligatorio'}
                                  </span>
                                </Box>
                              </FormControl>
                            </Grid>
                            : fieldData.type === 'textNumber' ?
                            <Grid item xs={12} md={6} lg={4} key={i}>
                              <FormControl fullWidth className={styles.itemForm}>
                                <label htmlFor={fieldData.id} className={`${fieldData.required && 'text-required'}`}>{fieldData.label}</label>
                                <div
                                  className={`${styles.containerItemTel} ${fieldData.required && (Object.keys(formik.errors).includes(fieldData.name)) && formik.touched[fieldData.name] && styles.errorCampo}`}>
                                  <Field
                                    id={fieldData.id}
                                    placeholder={fieldData.placeholder}
                                    type={fieldData.type}
                                    variant="outlined"
                                    name={fieldData.name}
                                    maxLength={fieldData.maxLength}
                                    className={""}
                                    autoComplete='off'
                                    onBlur={() => formik.setFieldTouched(fieldData.name)}
                                    onKeyPress={(event: any) => {
                                      isNaN(Number(event.key)) &&
                                          event.preventDefault();
                                      }}
                                    onPaste={onlyNumbers}
                                    data-testid={`input_${fieldData.name}`}
                                  />
                                  <span className={styles.itemIndicator}>+57</span>
                                </div>
                                <Box display='flex' justifyContent='space-between'>
                                  <span className={styles.spanError}>
                                    {fieldData.required && (Object.keys(formik.errors).includes(fieldData.name)) && formik.touched[fieldData.name] && 'Campo obligatorio'}
                                  </span>
                                  <span className={styles.spanCounter}>
                                    { formik?.values?.[fieldData.name]?.toString().length || 0}/{fieldData.maxLength}
                                  </span>
                                </Box>
                              </FormControl>
                            </Grid>
                            : fieldData.name === 'lastNames' || fieldData.name === 'names' ?
                              <Grid item xs={12} md={6} lg={4} key={i}>
                                <FormControl fullWidth className={styles.itemForm}>
                                  <label htmlFor={fieldData.id} className={`${fieldData.required && 'text-required'}`} >{fieldData.label} </label>
                                  <Field
                                    id={fieldData.id}
                                    placeholder={fieldData.placeholder}
                                    type={fieldData.type}
                                    variant="outlined"
                                    name={fieldData.name}
                                    maxLength={fieldData.maxLength}
                                    className={fieldData.required && Object.keys(formik.errors).includes(fieldData.name) ? formik.touched[fieldData.name] && styles.errorCampo : ""}
                                    onKeyPress={(event: any) => {
                                      const regex = /^[a-zA-Z]+$/;
                                      const inputChar = String.fromCharCode(event.charCode)

                                      !regex.test(inputChar) && event.preventDefault()
                                    }}
                                    data-testid={`input_${fieldData.name}`}
                                  />
                                  <Box display='flex' justifyContent='space-between'>
                                    <span className={styles.spanError}>
                                      {fieldData.required && Object.keys(formik.errors).includes(fieldData.name) && formik.touched[fieldData.name] && 'Campo obligatorio'}
                                    </span>
                                    <span className={styles.spanCounter}>
                                      { formik?.values?.[fieldData.name]?.toString().length || 0}/{fieldData.maxLength}
                                    </span>
                                  </Box>
                              </FormControl>
                              </Grid>
                            : <Grid item xs={12} md={6} lg={4} key={i}>
                                <FormControl fullWidth className={styles.itemForm}>
                                  <label htmlFor={fieldData.id} className={`${fieldData.required && 'text-required'}`}>{fieldData.label} </label>
                                  <Field
                                    id={fieldData.id}
                                    placeholder={fieldData.placeholder}
                                    type={fieldData.type}
                                    variant="outlined"
                                    name={fieldData.name}
                                    maxLength={fieldData.maxLength}
                                    className={fieldData.required && Object.keys(formik.errors).includes(fieldData.name) ? formik.touched[fieldData.name] && styles.errorCampo : ""}

                                  />
                                  <Box display='flex' justifyContent='space-between'>
                                    <span className={styles.spanError}>
                                      {fieldData.required && Object.keys(formik.errors).includes(fieldData.name) && formik.touched[fieldData.name] && 'Campo obligatorio'}
                                    </span>
                                    <span className={styles.spanCounter}>
                                      { formik?.values?.[fieldData.name]?.toString().length || 0}/{fieldData.maxLength}
                                    </span>
                                  </Box>
                                </FormControl>
                              </Grid>
                          ))
                        }
                      </Grid>

                  }
                </Form>
            )}
        </Formik>
      </div>
      {(isLoading) && <Spinner/>}
    </Fragment>
  )
}

const CustomFileUploaderMemo = React.memo(CustomFileUploader);